<app-modal></app-modal>
<app-confirm-modal></app-confirm-modal>
<mat-sidenav-container class="flyout-container" [fixedInViewport]="true" [fixedTopGap]="0"[fixedBottomGap]="0" (backdropClick)="toggle('close')" autosize>
  <mat-sidenav #sidenav mode="over" class="flyout wab-flyout-section" opened="false" [position]=pos>
    <button type="button" class="modal-close-left" aria-label="Close cart" (click)="toggle('close')" id="flyout-x">
      </button>
      <div class="flyout-body container-fluid">
        <div #flyoutbody></div>
      </div>
  </mat-sidenav>
  <mat-sidenav-content lass="sidenav-content">
    <div class="header-container-fixed" [ngClass]="{'isAssumedLocationBanner' : isFullMenuLoaded && !automaticDeliveryLocation}">
      <app-emergency-banner (onCloseEmergency) ='hideEmergencyBanner()' *ngIf="isEmergencyBanner" [isEmergencyBanner]="isEmergencyBanner"></app-emergency-banner>
      <app-header [isRewards]="isRewards" [isOrderingHeader]="isOrdering" [showCartIcon]="showCart"></app-header>
    </div>
    <div id="topAnchor" #topAnchor></div>
    <app-points-banner *ngIf="isRewards"></app-points-banner>
    <div class="landing-footer-container" [ngClass]="{'isEmergencyBanner' : isEmergencyBanner,'isOrdering' : isOrdering,  'isConfirmAndPay' : isConfirmAndPay, 'isContactSummary': isContactSummary, 'isSubNavPresent': isSubNavPresent, 'isPointsBanner' : isRewards, 'isDeliveryAddress' : isDeliveryAddressLoaded}" id="landingFooter" #landingFooter>
      <div class="landing-page wab-container" [ngClass]="{'isRewardsLanding' : isRewards, 'isGame': isGame}" #containerContent>
        <div class="main-content container-constraint" #mainContent id="mainContent">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-assumed-location-banner class="banner-sticky"  #locationBanner *ngIf="isFullMenuLoaded && !automaticDeliveryLocation"></app-assumed-location-banner>
      <div id="footerAnchor" #footerAnchor></div>
      <app-footer inViewport 
      (inViewportAction)="onViewPort($event)" [isOrdering]="isOrdering"></app-footer>
    </div>
    <div id="bottomAnchor" #bottomAnchor></div>
  </mat-sidenav-content>
</mat-sidenav-container>
<app-overlay></app-overlay>
<p-confirmDialog header="Are You Sure You Want To Leave?" #cd [baseZIndex]="10000">
  <p-footer>
      <button type="button" pButton icon="fa-check" aria-label="Leave" label="Leave" (click)="cd.accept()"></button>
      <button type="button" pButton icon="fa-close" aria-label="Cancel" label="Cancel" (click)="cd.reject()"></button>          
  </p-footer>
</p-confirmDialog>
